import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Col, Row } from "antd";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import {
  PrimaryButtonComponent,
  FixedWidth,
  SectionContent,
} from "../../../../CommonComponents/commonStyles";
import { fetchAccountAgreementData, newAgreement } from "./actions";
import { selectHeader } from "../../../../actions/globalActions";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import GrantAgreementSummary from "./Components/GrantAgreementSummary";
import { LinkWrapper } from "../RecommendGrant/style";
import { accountUpdated } from "./actions";
import {
  GrantAgreementPrimaryButtonWrapper,
  GrantAgreementGhostButton,
  GrantAgreementDisplayFlex,
  GrantAgreementContent,
  ButtonWrapper,
  GrantAgreementGrant,
  BtnWrapper,
  Wrapper,
} from "./styles";
import {
  todayDate,
  startDate,
  recordError,
  isAllShareAllPool,
} from "../../../../utils/commonUtil";
import {
  ContentProvider,
  Types,
  ContentMessage,
} from "../../../../CommonComponents/ContentMessages";
import { GeneralButton } from "../../../../CommonComponents/Commons/commonComponents";

import { landingPageDerivedStates } from './Selectors/LoadingPageSelectors';
import ErrorPopup from '../../../../CommonComponents/ErrorPopup/ErrorPopup';

export class GrantAgreementLandingPage extends Component {
  constructor(props) {
    super(props);
    this.routeChange = this.routeChange.bind(this);
    this.defaultContent =
      "<p>A grant agreement is a request from you asking Vanguard Charitable to enter into a legally binding agreement with a grantee organization. Grant Agreements typically stipulate a certain amount of charitable dollars, how those funds can be used and the reporting requirements that must be met prior to accepting the grant. The minimum grant amount of this agreement is $25,000. For more information about grant agreements, please read Request a Grant Agreement</p>\n\n<p><br />\nNot sure a grant agreement is the right choice for you? Please contact us at 888-383-4483.</p>";
  }

  componentDidMount() {
    const { grantAgreementFlag, history } = this.props;
    this.props.newAgreement();
    this.props.switchedAccount();
    window.scrollTo(0, 0);
    /**
     *  If Flag is true -> then Grant Agreement is Active
     *  If Flag is false -> then Grant Agreement is Disabled
     *  Keeping this commented untill development is in progress
     *  Uncomment before pushing to SIT
     */
    if (!grantAgreementFlag) {
      history.push("/");
    }

    const data = {
      metaData: {
        method: "GET",
        page: "grantAgreements",
        url: {
          grantAgreements: `/donor-portal/api/investment/${
            getPrimaryAccount().userId
          }/findInvestmentPoolsForGrantSubmitByAccountIdStartDateAndEndDate?startDateStr=${startDate(
            7
          )}&endDateStr=${todayDate()}`,
        },
      },
    };
    this.props.accData(data);
  }

  goToAccount = () => {
    try {
      this.props.selectHeader("ACCOUNT SUMMARY");
      this.props.history.push("/");
    } catch (error) {
      recordError(error);
    }
  };

  routeChange() {
    try {
      let path = `/grants/grant-agreement`;
      this.props.history.push(path);
      window.scrollTo(0, 0);
    } catch (error) {
      recordError(error);
    }
  }

  breadcrumbRoutes = () => {
    return [
      {
        routeName: "Home",
        path: "/",
      },
      {
        routeName: "Grants",
        path: "/grants",
      },
      {
        routeName: "Grant Agreements",
        path: "/GrantAgreement",
      },
    ];
  };

  render() {
    let isAllShareAllPoolStatus = isAllShareAllPool();
    if (isAllShareAllPoolStatus) {
      return (
        <ErrorPopup
          title="Alert"
          primaryCta={() => this.props.history && this.props.history.push('/')}
          show
        >
          <SectionContent>A grant has been recommended to close the account. Additional grant transactions cannot be submitted.</SectionContent>
        </ErrorPopup>
      );
    }
   return (
      <ContentProvider
        types={[Types.PAGE_TITLE_DESCRIPTION]}
        pages={["Grant Agreement Landing"]}
      >
        <FixedWidth>
          <div className="fluid">
            <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
            <GrantAgreementSummary />
            <GrantAgreementContent>
              <ContentMessage
                type={[Types.PAGE_TITLE_DESCRIPTION]}
                page={"Grant Agreement Landing"}
                html={true}
                property="description__value"
                defaultMessage={this.defaultContent}
              />
            </GrantAgreementContent>
            <Row>
              <Col xs={0} lg={24} md={24}>
                <ButtonWrapper>
                  <GrantAgreementDisplayFlex>
                    <BtnWrapper>
                      <GeneralButton
                        type="functional"
                        width="150px"
                        onClick={this.goToAccount}
                        id="btnCancel"
                        text="Cancel"
                        inverted={true}
                      ></GeneralButton>
                    </BtnWrapper>
                    <GrantAgreementPrimaryButtonWrapper>
                      <GeneralButton
                        type="functional"
                        width="200px"
                        onClick={this.routeChange}
                        id="btnRecommendAgreement"
                        text="Recommend Agreement"
                        className="contributenow_tooltip"
                      ></GeneralButton>
                    </GrantAgreementPrimaryButtonWrapper>
                  </GrantAgreementDisplayFlex>
                </ButtonWrapper>
              </Col>
              <Col xs={24} lg={0} md={0}>
                <BtnWrapper>
                  <GeneralButton
                    type="functional"
                    width="100%"
                    onClick={this.goToAccount}
                    id="btnCancelMob"
                    text="Cancel"
                    inverted={true}
                  ></GeneralButton>
                </BtnWrapper>
                <GrantAgreementPrimaryButtonWrapper>
                  <Wrapper>
                    <GeneralButton
                      type="functional"
                      width="100%"
                      onClick={this.routeChange}
                      id="btnRecommendAgreementMob"
                      text="Recommend Agreement"
                    ></GeneralButton>
                  </Wrapper>
                </GrantAgreementPrimaryButtonWrapper>
              </Col>
            </Row>
          </div>
        </FixedWidth>
      </ContentProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  ...landingPageDerivedStates(state.toJS()),
});

export const mapDispatchToProps = (dispatch) => ({
  accData: (data) => dispatch(fetchAccountAgreementData(data)),
  selectHeader: (data) => dispatch(selectHeader(data)),
  switchedAccount: () => dispatch(accountUpdated()),
  newAgreement: (data) => dispatch(newAgreement(data)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GrantAgreementLandingPage)
);
